import { LoaderNew, ModBox, TextNew, TextNewProps } from '@jfs/ui-new'
import { padZero } from '@jfs/utils'
import { useEffect, useState } from 'react'

interface ResendComponentProps {
  onResendOtp: any
  resendOtpState: any
}

const COUNTDOWN = 30
const COUNTDOWN_TIMER = 0
const SECOND = 1000

export const ResendComponent = ({ onResendOtp, resendOtpState }: ResendComponentProps) => {
  const [countDownTimer, setCountDownTimer] = useState(COUNTDOWN)

  useEffect(() => {
    let timer: any
    if (countDownTimer > 0) {
      timer = setInterval(() => setCountDownTimer(countDownTimer - 1), SECOND)
    }
    //Clear all the subscriptions and listeners on unmount
    return () => clearInterval(timer)
  }, [countDownTimer])

  useEffect(() => {
    console.log('resendOtpState', resendOtpState)
    if (resendOtpState === 'fulfilled') {
      setCountDownTimer(COUNTDOWN)
    }
  }, [resendOtpState])

  const showTimeTickling = countDownTimer > COUNTDOWN_TIMER && countDownTimer <= COUNTDOWN
  if (resendOtpState === 'pending') {
    return <LoaderNew type={'small'} color={'PRIMARY'} />
  } else {
    return showTimeTickling ? (
      <TextNew {...styles.timerText} title={`00:${padZero(countDownTimer)}`} />
    ) : (
      <ModBox
        onPress={() => {
          onResendOtp()
        }}
        underlayColor={'LIGHTEST_GREY'}
        flexDirection="row">
        <TextNew {...styles.resendText} title="RESEND" />
      </ModBox>
    )
  }
}

const styles = {
  resendText: {
    fontSize: 14,
    fontFamily: 'jiotype-medium',
    color: 'PRIMARY',
    textDecorationLine: 'underline',
  } as TextNewProps,
  countText: {
    fontSize: 14,
    fontFamily: 'jiotype-medium',
    color: 'PRIMARY',
  } as TextNewProps,
  timerText: {
    fontSize: 14,
    fontFamily: 'jiotype-medium',
    color: 'PRIMARY',
    letterSpacing: 1,
  } as TextNewProps,
}
